/** The public web client (Cloudflare Pages): invites open it, and only it waits for an invite and keeps the build installed. */
export const PUBLIC_CLIENT_URL = 'https://nimblez.pages.dev/';
export interface GameInvite { serverUrl: string | null; room: string; sessionKey: string | null }
export function validateServerUrl(value: string): string {
  const url = new URL(value);
  const local = ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname);
  if (url.username || url.password || url.search || url.hash || url.pathname !== '/' ||
    !(local ? ['http:', 'https:'].includes(url.protocol) : url.protocol === 'https:' && url.hostname.endsWith('.trycloudflare.com'))) {
    throw new Error('This invite must point to a Cloudflare host or a local development server.');
  }
  return url.origin;
}
export function readInvite(value: string): GameInvite {
  const url = new URL(value), fragment = new URLSearchParams(url.hash.slice(1));
  const room = (url.searchParams.get('room') || 'CROSSING').toUpperCase();
  if (!/^[A-Z0-9-]{3,24}$/.test(room)) throw new Error('Invalid room code in invite.');
  const server = fragment.get('server'), key = fragment.get('key');
  if (key && !/^[A-Za-z0-9_-]{24,128}$/.test(key)) throw new Error('Invalid session key in invite.');
  return { room, serverUrl: server ? validateServerUrl(server) : null, sessionKey: key };
}
/** Like readInvite, but a malformed room code falls back to the default room so the typed code can still be used. */
export function readInviteForForm(value: string): GameInvite {
  try { return readInvite(value); } catch (error) {
    if (!(error instanceof Error) || !error.message.startsWith('Invalid room code')) throw error;
    const url = new URL(value); url.searchParams.delete('room');
    return readInvite(url.href);
  }
}
export function createInviteUrl(clientUrl: string, invite: GameInvite): string {
  const url = new URL(clientUrl); url.search = ''; url.hash = '';
  url.searchParams.set('room', invite.room);
  const fragment = new URLSearchParams();
  if (invite.serverUrl) fragment.set('server', validateServerUrl(invite.serverUrl));
  if (invite.sessionKey) fragment.set('key', invite.sessionKey);
  url.hash = fragment.toString(); return url.href;
}
